import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
  Typography,
  TablePagination,
} from "@mui/material";
import { useGetList } from "../../../../hooks/useGetList";
import { useSelector, useDispatch } from "react-redux";
import StockCountAndPriceListRow from "./StockCountAndPriceListRow";
import StockCountAndPriceBatchDialog from "./StockCountAndPriceBatchDialog";
import {
  setPage,
  setLimit,
} from "../../../../redux/stockCountAndPrice/stockCountAndPriceSlice";
import buildParams from "../../../../Utils/buildParams";
const LoadingSkeleton = () => (
  <TableContainer>
    <Table stickyHeader aria-label="loading skeleton">
      <TableHead>
        <TableRow sx={{ backgroundColor: "#f8fafc" }}>
          {[
            "Item Code",
            "Item Name",
            "Unit",
            "Purchase Price",
            "Selling Price",
            "Qty",
            "Reorder Qty",
            "Stock Status",
            "Actions",
          ].map((col) => (
            <TableCell key={col} sx={{ fontWeight: 600 }}>
              <Skeleton
                variant="text"
                width={col === "Item Name" ? 100 : 70}
                height={20}
              />
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {[...Array(5)].map((_, index) => (
          <TableRow key={index}>
            {[...Array(9)].map((__, i) => (
              <TableCell key={i}>
                <Skeleton
                  variant="text"
                  width={i === 1 ? 120 : 70}
                  height={20}
                />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

const StockCountAndPriceList = () => {
  const dispatch = useDispatch();
  const filter = useSelector((state) => state.filterStockCountAndPrice);

  const param = buildParams(filter);
  const hasBranch =
    !!filter?.filterType?.relatedBranch &&
    filter?.filterType?.relatedBranch !== "All";
  const queryParams = hasBranch
    ? Object.keys(param).length > 0
      ? param
      : undefined
    : { page: filter.page, limit: filter.limit };

  const { data, loading, fetchData } = useGetList(
    "stock-count-price",
    true,
    queryParams,
  );

  const [selectedRow, setSelectedRow] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleStockBatch = (row) => {
    setSelectedRow(row);
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setSelectedRow(null);
  };

  console.log(filter);

  useEffect(() => {
    const params = hasBranch
      ? Object.keys(param).length > 0
        ? param
        : undefined
      : { page: filter.page, limit: filter.limit };
    fetchData(params);
  }, [filter]);

  const handleChangePage = (e, page) => {
    dispatch(setPage(page + 1));
  };

  const handleChangeRowsPerPage = (e) => {
    dispatch(setLimit(e.target.value));
    dispatch(setPage(1));
  };

  const totalCount = data?.pagination?.total || 0;

  return (
    <>
      {loading ? (
        <LoadingSkeleton />
      ) : !data || !data.data || data.data.length === 0 ? (
        <TableContainer>
          <Table stickyHeader aria-label="stock count and price table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, minWidth: 120 }}>
                  Branch
                </TableCell>
                <TableCell sx={{ fontWeight: 600, minWidth: 120 }}>
                  Item Code
                </TableCell>
                <TableCell sx={{ fontWeight: 600, minWidth: 180 }}>
                  Item Name
                </TableCell>
                <TableCell sx={{ fontWeight: 600, minWidth: 100 }}>
                  Unit
                </TableCell>
                <TableCell
                  sx={{ fontWeight: 600, minWidth: 120 }}
                  align="right"
                >
                  Purchase Price
                </TableCell>
                <TableCell
                  sx={{ fontWeight: 600, minWidth: 120 }}
                  align="right"
                >
                  Selling Price
                </TableCell>
                <TableCell sx={{ fontWeight: 600, minWidth: 80 }} align="right">
                  Quantity
                </TableCell>
                <TableCell
                  sx={{ fontWeight: 600, minWidth: 100 }}
                  align="right"
                >
                  Reorder Qty
                </TableCell>
                <TableCell
                  sx={{ fontWeight: 600, minWidth: 120 }}
                  align="center"
                >
                  Stock Status
                </TableCell>
                <TableCell
                  sx={{ fontWeight: 600, minWidth: 100 }}
                  align="center"
                >
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell colSpan={9} align="center" sx={{ py: 8 }}>
                  <Box sx={{ textAlign: "center" }}>
                    <Typography
                      variant="h6"
                      color="text.secondary"
                      gutterBottom
                    >
                      No stock count and price data found
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      There are currently no stock count and price records
                      available for the selected branch.
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <TableContainer>
          <Table stickyHeader aria-label="stock count and price table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, minWidth: 120 }}>
                  Branch
                </TableCell>
                <TableCell sx={{ fontWeight: 600, minWidth: 120 }}>
                  Item Code
                </TableCell>
                <TableCell sx={{ fontWeight: 600, minWidth: 180 }}>
                  Item Name
                </TableCell>
                <TableCell sx={{ fontWeight: 600, minWidth: 100 }}>
                  Unit
                </TableCell>
                <TableCell
                  sx={{ fontWeight: 600, minWidth: 120 }}
                  align="right"
                >
                  Purchase Price
                </TableCell>
                <TableCell
                  sx={{ fontWeight: 600, minWidth: 120 }}
                  align="right"
                >
                  Selling Price
                </TableCell>
                <TableCell sx={{ fontWeight: 600, minWidth: 80 }} align="right">
                  Quantity
                </TableCell>
                <TableCell
                  sx={{ fontWeight: 600, minWidth: 100 }}
                  align="right"
                >
                  Reorder Qty
                </TableCell>
                <TableCell
                  sx={{ fontWeight: 600, minWidth: 120 }}
                  align="center"
                >
                  Stock Status
                </TableCell>
                <TableCell
                  sx={{ fontWeight: 600, minWidth: 100 }}
                  align="center"
                >
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.data.map((row) => (
                <StockCountAndPriceListRow
                  key={row._id}
                  row={row}
                  onStockBatch={handleStockBatch}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      {data?.data?.length > 0 && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={totalCount}
          rowsPerPage={filter.limit}
          page={filter.page - 1}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            "& .MuiTablePagination-toolbar": {
              display: "flex",
              alignItems: "center",
              minHeight: "52px",
            },
            "& .MuiTablePagination-selectLabel": {
              margin: 0,
              display: "flex",
              alignItems: "center",
            },
            "& .MuiTablePagination-displayedRows": {
              margin: 0,
              display: "flex",
              alignItems: "center",
            },
            "& .MuiTablePagination-actions": {
              display: "flex",
              alignItems: "center",
            },
          }}
        />
      )}

      <StockCountAndPriceBatchDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        selectedProductItemUnit={selectedRow}
        id={selectedRow?.relatedItem?._id}
        selectedBranch={filter?.filterType?.relatedBranch}
      />
    </>
  );
};

export default StockCountAndPriceList;
